import { array, boolean, InferType, object, string } from "yup";

const normalize = (abbr: string) => abbr.replace(/[^a-zA-Z0-9]/g, "-");

export const addRateComponentSchema = (defaultLanguage: string) =>
  object().shape({
    name: array()
      .of(
        object({
          language: string().required(),
          value: string()
            .ensure()
            .when("language", ([language], schema) =>
              normalize(defaultLanguage) === normalize(language) ? schema.required() : schema.nullable()
            ),
        }).required()
      )
      .required()
      .default([]),
    code: string().required().default(""),
    archived: boolean().default(false),
    description: string().default(""),
  });
export type AddRateComponentFormFields = InferType<ReturnType<typeof addRateComponentSchema>>;
